// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-VgX","type":"styles_type__j3HrV","choices":"styles_choices__3PGo_"};